import React, {createContext, useContext, useCallback} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const ConnectionObjectApiContext = createContext(null);

export function ConnectionObjectApiProvider({children}) {

  const {get, post, put, del} = useApiService(CONFIG.SERVER_ORGANIZATION);

  const getConnectionObjects = useCallback(async (skip, limit) => {
    if (!skip) {
      skip = 0;
    }
    if (!limit) {
      limit = 10;
    }
    try {
      const response = await get(
        `/v1/connection_objects?skip=${skip}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching connection objects:", error);
      throw error;
    }
  }, [get]);

  const getConnectionObjectById = useCallback(async (connectionObjectId) => {
    try {
      const response = await get(`/v1/connection_objects/${connectionObjectId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching connection object by ID:", error);
      throw error;
    }
  }, [get]);

  const createConnectionObject = useCallback(async (connectionObject) => {
    try {
      const response = await post(`/v1/connection_objects`, connectionObject);
      return response.data;
    } catch (error) {
      console.error("Error creating connection object:", error);
      throw error;
    }
  }, [post]);

  const updateConnectionObjectById = useCallback(async (connectionObjectId, connectionObject) => {
    try {
      const response = await put(`/v1/connection_objects/${connectionObjectId}`, connectionObject);
      return response.data;
    } catch (error) {
      console.error("Error updating connection object:", error);
      throw error;
    }
  }, [put]);

  const deleteConnectionObject = useCallback(async (connectionObjectId) => {
    try {
      const response = await del(`/v1/connection_objects/${connectionObjectId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting connection object:", error);
      throw error;
    }
  }, [del]);

  const getConnections = useCallback(async () => {
    try {
      const response = await get(`/v1/connections`);
      return response.data.items;
    } catch (error) {
      console.error("Error fetching connections:", error);
      throw error;
    }
  }, [get]);

  return (
    <ConnectionObjectApiContext.Provider value={{
      getConnectionObjects,
      getConnectionObjectById,
      createConnectionObject,
      updateConnectionObjectById,
      deleteConnectionObject,
      getConnections,
    }}>
      {children}
    </ConnectionObjectApiContext.Provider>
  );
}

export function useConnectionObjectApi() {
  const context = useContext(ConnectionObjectApiContext);
  if (!context) {
    throw new Error("useConnectionObjectApi must be used within a ConnectionObjectApiProvider");
  }
  return context;
}
